import { BusinessTwoTone } from "@mui/icons-material";

const BusinessIcon = () => {
  return <BusinessTwoTone />;
};

export default BusinessIcon;
